import { Character } from "@src/types/global";
import { api } from "@src/utils/axios-instance";

export async function fetchByName(
    name: string,
): Promise<{ accessible_characters: Character[] }> {
    const { data } = await api.get("characters/?name=" + name);
    return data.data;
}


export async function getAllCharacters(): Promise<{ characters: Character[] }> {
    const res = await api.get("/characters");
    return res.data.data;
}
